import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UserType } from '../../../interface';
import { useTranslation } from 'react-i18next';
import {
	Avatar,
	Button,
	Col,
	Input,
	Row,
	Select,
	SelectOption,
	Slider,
	Toast,
} from '@kaleyra/emmy';
import { IStateType } from '../../../store/models/root.interface';

import Styles from './index.module.scss';
import { TimezoneType } from '../../../interface/timezone';
import ErrorIcon from '../../../assets/error.png';
import { addFullProfile } from '../../../store/actions/profile.action';
import { checkIsNonPrimaryRole, checkPrivileges, checkSubaccount } from '../../../utils';

export type MapStateType = {
	profile?: UserType;
	timezoneData?: TimezoneType[];
	photoS3LinkData?: any;
};

export type DispatchPropsType = {
	onClick: () => void;
	fetchTimezones: () => void;
	uploadPhoto: (data: any, callBack: any) => void;
	saveProfileDetails: (data: any, callBack: any) => void;
};

const ProfileSetting: React.FC<MapStateType & DispatchPropsType> = ({
	onClick,
	profile,
	timezoneData,
	fetchTimezones,
	uploadPhoto,
	photoS3LinkData,
	saveProfileDetails,
}) => {
	const { t } = useTranslation();
	const accountName: any = profile?.account_name;
	const {
		profile_picture: picture,
		full_name: name,
		company_name: companyName,
		email,
		timezone,
		mobile: phone,
	} = profile || {};

	const [profileName, setProfileName] = useState(name);
	const [cmpanyName, setCompanyName] = useState(companyName);
	const [timeZoneId, setTimeZoneId] = useState(timezone?.id);
	const [timeZone, setTimeZone] = useState(timezone?.time_zone);
	const balance = useSelector((state: IStateType) => state.balance);
	const [nameErr, setNameErr] = useState(false);
	const [companyErr, setCompanyErr] = useState(false);
	const regex = /^[a-zA-Z0-9 ]+$/i;
	const [disableBtn, setDisableBtn] = useState(false);
	const dispatch = useDispatch();
	const [dp, setDP] = useState(picture);

	useEffect(() => {
		fetchTimezones();
	}, []);

	const getProfileImage = () => {
		return (
			<Row>
				<Col size={2} className={Styles.profilePicture}>
					<Avatar name={checkSubaccount() ? accountName : name} round={true} size={50} imgUrl={dp} />
				</Col>
				<Col size={10}>
					<div className={Styles.editInput}>
						<label className={Styles.labelWidth}>
							{t('photoChange')}
							<Input
								type={'file'}
								hidden={true}
								id={'edit'}
								value=""
								onChange={(e: any) => {
									let formData = new FormData();
									formData.append(
										'document_ids',
										e.target.files[0]
									);
									uploadPhoto(
										formData,
										(resp: any, status: boolean) => {
											if (resp?.status === 200) {
												setDP(
													resp?.data?.profile_picture
												);
											} else if (resp?.code === 400) {
												Toast(resp?.message, 'error');
											} else if (
												resp?.data?.code === '400'
											) {
												Toast(
													resp?.data?.message,
													'error'
												);
											}
										}
									);
								}}
							/>
						</label>
					</div>
				</Col>
			</Row>
		);
	};

	const getCurrencyValue = (): string => {
		// const amount = (balance.isPostpaid
		// 	? balance.maxPostpaidLimit - balance.baseCurrencyVal
		// 	: balance.baseCurrencyVal
		// ).toLocaleString(undefined, {
		// 	minimumFractionDigits: 2,
		// 	maximumFractionDigits: 2,
		// });
		return `${balance.fullBalanceObject?.base_currency_code} ${balance.baseCurrencySymbol}`;
	};

	const validateCheck = (field: string, value: string | undefined) => {
		if (field === 'name') {
			if (
				!value?.length ||
				value.length < 3 ||
				!regex.test(value) ||
				value.length > 40
			) {
				return true;
			} else {
				return false;
			}
		} else if (field === 'company') {
			if (!value?.length || (value && value.trim().length > 250)) {
				return true;
			} else {
				return false;
			}
		}
	};

	const validateFields = (field: string): 'error' | undefined => {
		if (field === 'name') {
			if (
				profileName === '' ||
				(profileName && !regex.test(profileName)) ||
				(profileName && profileName.length < 3) ||
				(profileName && profileName.length > 40)
			) {
				return 'error';
			}
		}

		if (field === 'company') {
			if (
				cmpanyName === '' ||
				(cmpanyName && cmpanyName.trim().length > 250)
			) {
				return 'error';
			}
		}

		return undefined;
	};

	const setErrors = (field: string) => {
		if (field === 'name') {
			if (!profileName || profileName.trim().length === 0) {
				return (
					<>
						<img
							src={ErrorIcon}
							alt=""
							className={Styles.errorIcon}
						/>

						{t('fullNameReq')}
					</>
				);
			} else if (profileName && !regex.test(profileName)) {
				return (
					<>
						<img
							src={ErrorIcon}
							alt=""
							className={Styles.errorIcon}
						/>

						{t('fullNameInvalid')}
					</>
				);
			} else if (profileName.length < 3) {
				return (
					<>
						<img
							src={ErrorIcon}
							alt=""
							className={Styles.errorIcon}
						/>

						{t('fullNameMin3')}
					</>
				);
			} else if (profileName.length > 40) {
				return (
					<>
						<img
							src={ErrorIcon}
							alt=""
							className={Styles.errorIcon}
						/>

						{t('fullNameMax40')}
					</>
				);
			}
		}

		if (field === 'company') {
			if (!cmpanyName || cmpanyName.trim().length === 0) {
				return (
					<>
						<img
							src={ErrorIcon}
							alt=""
							className={Styles.errorIcon}
						/>

						{t('companyNameReq')}
					</>
				);
			} else if (cmpanyName.trim().length > 250) {
				return (
					<>
						<img
							src={ErrorIcon}
							alt=""
							className={Styles.errorIcon}
						/>

						{t('companyNameMax')}
					</>
				);
			}
		}
	};

	const handleNameOnBlur = () => {
		if (validateCheck('name', profileName)) {
			setNameErr(true);
			return;
		} else {
			setNameErr(false);
			return;
		}
	};

	const handleCompanyOnBlur = () => {
		if (validateCheck('company', cmpanyName)) {
			setCompanyErr(true);
			return;
		} else {
			setCompanyErr(false);
			return;
		}
	};

	const saveProfileSetting = (): void => {
		setDisableBtn(true);
		let data = {
			full_name: profileName,
			company_name: cmpanyName,
			time_zone_id: timeZoneId,
			profile_picture: dp,
		};
		let newProfile: any = { ...profile };
		if (newProfile) {
			newProfile.full_name = profileName!;
			newProfile.company_name = cmpanyName!;
			newProfile.timezone.id = timeZoneId;
			newProfile.timezone.time_zone = timeZone;
			newProfile.profile_picture = dp;
		}

		saveProfileDetails(data, (resp: any, status: boolean) => {
			if (status) {
				dispatch(addFullProfile(newProfile));
				Toast(t('reqExec'), 'success');
				onClick();
			} else {
				Toast(resp?.data?.message, 'error');
				setDisableBtn(false);
			}
		});
	};

	const checkButtonEnabled = (
		field1: string,
		value1: string | undefined,
		field2: string,
		value2: string | undefined
	) => {
		if (validateCheck(field1, value1) || validateCheck(field2, value2)) {
			setDisableBtn(true);
		} else {
			setDisableBtn(false);
		}
	};

	const getBody = () => {
		return (
			<>
				{getProfileImage()}
				<Input
					placeholder={t('BLD00374')}
					label={t('BLD00374')}
					value={profileName}
					onChange={(e) => {
						setNameErr(false);
						setProfileName(e.target.value);
						checkButtonEnabled(
							'name',
							e.target.value,
							'company',
							cmpanyName
						);
					}}
					bottomLabelType={
						nameErr ? validateFields('name') : undefined
					}
					bottomLabel={nameErr ? setErrors('name') : null}
					showBottomLabelSpace={nameErr}
					className={Styles.inputPadding}
					onBlur={(e: any) => {
						handleNameOnBlur();
					}}
				/>
				{/* <Input
					placeholder={t('lastName')}
					label={t('lastName')}
					value={profileName}
					onChange={(e) => setProfileName(e.target.value)}
					showBottomLabelSpace={false}
					className={Styles.inputPadding}
				/> */}
				{(checkSubaccount()) ?
					<Input
						placeholder='Account Name'
						label='Account Name'
						disabled
						value={checkSubaccount() ? accountName : companyName}
						className={Styles.inputPadding}
						showBottomLabelSpace={false}

					/>
					: (
						<Input
							placeholder={t('companyName')}
							label={t('companyName')}
							value={cmpanyName}
							disabled={checkIsNonPrimaryRole()}
							onChange={(e) => {
								setCompanyErr(false);
								setCompanyName(e.target.value);
								checkButtonEnabled(
									'company',
									e.target.value,
									'name',
									profileName
								);
							}}
							bottomLabelType={
								companyErr ? validateFields('company') : undefined
							}
							bottomLabel={companyErr ? setErrors('company') : null}
							showBottomLabelSpace={companyErr}
							className={Styles.inputPadding}
							onBlur={(e: any) => {
								handleCompanyOnBlur();
							}}
						/>
					)}
				<Select
					showSearch
					bordered
					label={t('selectTimeZone')}
					onChange={(e: any, val: any) => {
						setTimeZone(val.label);
						setTimeZoneId(e);
					}}
					placeholder={t('selectTimeZone')}
					showBottomLabelSpace={false}
					className={Styles.inputPadding}
					value={timeZone}
					filterOption={(input: any, option: any) =>
						option.children
							.toLowerCase()
							.indexOf(input.toLowerCase()) >= 0
					}
				>
					{timezoneData &&
						timezoneData.map((entry) => {
							let tz = entry.time_zone.replace('&amp;', '&');
							tz = tz.replace(')', ') ');
							return (
								<SelectOption
									value={entry.id}
									label={tz}
									key={entry.id}
								>
									{tz}
								</SelectOption>
							);
						})}
				</Select>
				<Input
					placeholder={t('mainEmailAddress')}
					label={t('mainEmailAddress')}
					value={email}
					disabled={true}
					showBottomLabelSpace={false}
					className={Styles.inputPadding}
				/>
				<Input
					placeholder={t('mainMobileNumber')}
					label={t('mainMobileNumber')}
					value={phone}
					disabled={true}
					showBottomLabelSpace={false}
					className={Styles.inputPadding}
				/>
				{checkPrivileges('prices', 'main') &&
					<Input
						placeholder={t('currency')}
						label={t('currency')}
						value={getCurrencyValue()}
						showBottomLabelSpace={false}
						disabled={true}
						className={Styles.inputPadding}
					/>
				}
			</>
		);
	};

	const getFooter = (): React.ReactNode => {
		return (
			<div className={Styles.footerContainer}>
				<Button type="tertiary" onClick={onClick}>
					{t('mainCancel')}
				</Button>
				<Button
					type="primary"
					onClick={() => saveProfileSetting()}
					disabled={disableBtn}
				>
					{t('mainSaveChanges')}
				</Button>
			</div>
		);
	};

	return (
		<>
			<Slider
				visibility={true}
				title={t('profileSettings')}
				onClose={onClick}
				containerId="root-modal"
				footer={getFooter()}
			>
				{getBody()}
			</Slider>
		</>
	);
};
export default ProfileSetting;
